"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pauses = void 0;
const react_1 = __importDefault(require("react"));
const i18n_1 = require("@app/util/i18n");
const moment_1 = __importDefault(require("moment"));
const Pauses = ({ details }) => {
    const _getStartTimeStr = (s) => {
        const h = Math.floor(s ?? 0);
        const m = Math.floor(((s ?? 1) % 1) * 60);
        return h.toString() + (0, i18n_1.t)('HOUR_SHORT') + (m > 0 ? ' ' + m.toString() + (0, i18n_1.t)('MINUTE_SHORT') : '');
    };
    return (details?.pauses?.length
        ? (react_1.default.createElement("div", { className: 'ds-viewshift-row' },
            react_1.default.createElement("div", { className: 'ds-viewshift-col-label' }, (0, i18n_1.t)('PAUSES_SHORT')),
            react_1.default.createElement("div", { className: 'ds-viewshift-col-value', style: { display: details.pauses.length >= 2 ? 'block' : undefined } }, details.pauses.map((p, idx) => {
                const pstr = p.duration.toString() +
                    (0, i18n_1.t)('MINUTE_SHORT') +
                    ' - ' +
                    (0, i18n_1.t)('PAUSE_AFTER').toLowerCase() +
                    ' ' +
                    _getStartTimeStr(p.start / 60) +
                    ' (' +
                    (0, i18n_1.t)('IN') +
                    ' ' +
                    (0, moment_1.default)(details.period.start).add(p.start, 'minutes').format('H:mm') +
                    ')';
                return (react_1.default.createElement("div", { key: 'p_' + idx.toString(), className: 'ds-vsr-pause' }, pstr));
            }))))
        : null);
};
exports.Pauses = Pauses;
